<template>
  <div class="cts-box" :class="customClass" v-if="!!item.name">
    <!-- <div class="introduction"> -->
    <div class="introduction" @click="goDetail()">
      <img class="left" :src="item.avatar" alt="">
      <div class="right">
        <div class="top">
          <div class="top-left">
            <div class="name text-ellipsis-2">
              {{ item.name || '暂无' }}
            </div>
            <div class="position text-ellipsis-2">
              {{ item.position }}
            </div>
          </div>
          <div class="top-right" v-if="!hideControl">
            <!-- 打电话 -->
            <div class="call-phone">
              <a :href="phoneNumber" @click.stop="callPhone">
                <i class="iconfont baseColor" :style="getMainColor">
                  {{ `\ue780` }}
                </i>
              </a>
            </div>
            <!-- im -->
            <div class="im" @click.stop="callIm()">
              <div class="iconfont baseColor" :style="getMainColor">
                {{ `\ue77f` }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="center">
          {{ item.dutyDescription }}
        </div>
        <div class="bottom baseColor text-ellipsis-overflow-1">
          <template v-for="(sitem, index) in item.productName">
            {{ sitem }}
          </template>
        </div> -->
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'aigcContactItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    customItemClass: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'CN',
    },
    customClass: {
      type: [String, Array],
      default: 'mt-10',
    },
    hideControl: {
      type: Boolean,
      default: false,
    },
    isStyle: {
      type: String,
      default: '',
    },
    mainColor: {
      type: String,
      default: '',
    }
  },
  components: {},
  computed: {
    phoneNumber() {
      return `tel:${this.item.phone}`
    },
    getMainColor() {
      return this.mainColor ? `color:${this.mainColor}` : 'color:#00c4c9'
    },
  },
  data() {
    return {
      isWxMini: window.__wxjs_environment === 'miniprogram',
    }
  },
  methods: {
    goDetail() {
      if (this.isWxMini) {
        wx.miniProgram.navigateTo({
          url: `/subPackage/social/pages/user-main-page/contactMainPage?targetUid=${this.item.uid}&language=${this.language}`,
        })
      } else {
        this.$router.push(`/mini-h5/index/mainPage?uid=${this.item.uid}&language=${this.language}`)
      }
    },
    callPhone() {},
    callIm() {
      // this.$isLogin().then((res) => {
      let userBasicInfo = JSON.parse(localStorage.getItem('userInfo'))
      let imUrl = process.env.VUE_APP_IM_BASE_URL + `/#/detail?uid=${userBasicInfo.imUid}&fUserId=${this.item.imUid}&userName=${this.item.name}&language=${this.language}`
      location.href = imUrl
      // })
    },
  },
  mounted() {},
}
</script>
<style scoped>
.cts-box {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  padding: 5px 10px 5px 5px;
}

.introduction {
  display: flex;
  flex: 1;
}

.introduction .left {
  display: block;
  width: 50px !important;
  height: 50px;
  margin-right: 7px;
  flex-shrink: 0;
  background-color: #f5f5f5;
  border-radius: 50%;
}

.right {
  flex: 1;
  margin-top: 8px;
  color: #8c8c8c;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.right .top {
  display: flex;
}
.right .top .top-left {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  flex: 1;
}

.right .top .top-left .name {
  font-size: 14px;
  color: #000000;
  font-weight: 700;
  line-height: 1.1;
}

.right .top .top-left .position {
  font-size: 12px;
  color: #000000;
  /* line-height: 1; */
  margin-top: 1px;
}
.right .top .top-right {
  display: flex;
  font-size: 14px;
  margin-left: auto;
}

.call-phone,
.im {
  width: 27px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: #f5f5f5;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 16px;
}
.center,
.bottom {
  /* width: 309px; */
  width: calc(100vw - 100px);
  font-size: 12px;
  margin-top: 3px;
  text-align: justify;
}
.baseColor {
  color: #00c4c9;
}
</style>